module.exports = __webpack_public_path__ + "static/media/About-Us.2f03e78a.jpg";